import React, { useState } from "react";
import { Modal, Button, CloseButton } from "react-bootstrap";
import { ValidatorForm } from "react-form-validator-core";
import TextValidator from "../../partial/TextValidator";
import { UpdateMembership } from "../../../actions/auth";
import swal from "sweetalert";
import { decrypt } from "../../../utils/encodingdecoding";
import { useLocation } from "react-router-dom";

const HanldeView = (props) => {
    const [data,setData] = useState()
    const location =useLocation()
    const allDAta = location.state.transactionId
    const [loader, setLoader] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        let token = JSON.parse(localStorage.getItem("token_gen"));
        const id = decrypt(localStorage.getItem("Id"))
        const body = {
            
                TransactionDate: allDAta.TransactionDate,
                membershipType: allDAta.membershipType,
                amount:allDAta.amount ,
                transactionStatus: allDAta.transactionStatus,
                remarks: data
            
        }
        setLoader(true);
       const response =  UpdateMembership(token?.access_token,id,allDAta.mobile,body)
       console.log(response)
       setLoader(false)
          
    };
const handleChange = (e) =>{
    setData(e.target.value)
}
    return (
        <>
            <Modal show={props.show} onHide={props.close} size="lg" centered>
                <Modal.Header>
                    <Modal.Title style={{ fontSize: "20px" }}>Remarks</Modal.Title>
                    <CloseButton onClick={props.close} variant="black" />
                </Modal.Header>
                <Modal.Body
                    className="dashboard__transactionsModal"
                    style={{ position: "relative", minHeight: "85px" }}
                >
                      <ValidatorForm className="signUpPage__formSection" onSubmit={handleSubmit} >
                    <div className="modal-body">
                        <div className="form-group">
                            <TextValidator placeholder="Remarks" onChange={handleChange} value={data} type="text" name="remarks" className="form-control"validators={["required"]} errorMessages={["Please enter your remarks"]} />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="submit" className="btn btn-primary">Submit</button>
                    </div>
                    </ValidatorForm> 
                </Modal.Body>

            </Modal>

        </>
    );
};

export default HanldeView;